import React, { useState, useEffect } from 'react';
import { authToken } from '../../authToken';
import CloseButton from '../../components/CloseButton';
import { API_BASE_URL } from '../../config';

const ENDPOINT_HOST = API_BASE_URL;
const ENDPOINT_BASE = `${ENDPOINT_HOST}/base`;

export default function BaseListPanel() {
  const [baseRecords, setBaseRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    fetchBaseRecords();
  }, []);

  const fetchBaseRecords = async () => {
    try {
      const response = await fetch(ENDPOINT_BASE, {
        headers: {
          ...(authToken ? { 'Authorization': authToken } : {})
        }
      });
      if (response.ok) {
        const data = await response.json();
        // Sort by timestamp descending (newest first)
        const sortedData = Array.isArray(data) ? data.sort((a, b) => b.timestamp - a.timestamp) : [];
        setBaseRecords(sortedData);
      } else {
        console.error(`Failed to fetch base records (${response.status})`);
        setBaseRecords([]);
      }
    } catch (error) {
      console.error('Failed to fetch base records:', error);
      setBaseRecords([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (record) => {
    setDeleteConfirm(record);
  };

  const confirmDelete = async () => {
    if (!deleteConfirm) return;
    
    try {
      const response = await fetch(`${ENDPOINT_BASE}/${deleteConfirm.id}`, {
        method: 'DELETE',
        headers: {
          ...(authToken ? { 'Authorization': authToken } : {})
        }
      });
      
      if (response.ok) {
        // Remove the deleted record from the list
        setBaseRecords(prev => prev.filter(record => record.id !== deleteConfirm.id));
      } else {
        alert(`Failed to delete record (${response.status})`);
      }
    } catch (error) {
      console.error('Failed to delete record:', error);
      alert('Failed to delete record');
    }
    
    setDeleteConfirm(null);
  };

  const cancelDelete = () => {
    setDeleteConfirm(null);
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatValue = (record) => {
    // Handle different possible base record formats
    if (record.base !== undefined) {
      return `${record.base}`;
    }
    if (record.value !== undefined) {
      return `${record.value}`;
    }
    if (record.units !== undefined) {
      return `${record.units} units`;
    }
    return 'Unknown value';
  };

  return (
    <div style={{ padding: '20px 0' }}>
      <h3 style={{ margin: '0 0 20px 0', textAlign: 'center' }}>📋 Base History</h3>
      
      {loading ? (
        <div style={{ textAlign: 'center', color: '#666' }}>Loading...</div>
      ) : baseRecords.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#666' }}>No base records found</div>
      ) : (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {baseRecords.map((record) => (
            <div
              key={record.id}
              onClick={() => handleDeleteClick(record)}
              style={{
                padding: '8px 12px',
                margin: '4px 0',
                backgroundColor: '#f8f9fa',
                borderRadius: '6px',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: '14px',
                transition: 'background-color 0.2s',
                border: '1px solid #e9ecef'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#f8f9fa'}
            >
              <span style={{ color: '#666' }}>
                {formatTimestamp(record.timestamp)}
              </span>
              <span style={{ fontWeight: '500', color: '#f6e96b' }}>
                {formatValue(record)}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteConfirm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 20000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            maxWidth: '300px',
            width: '90%'
          }}>
            <h4 style={{ margin: '0 0 16px 0', textAlign: 'center' }}>Delete Record</h4>
            <p style={{ margin: '0 0 20px 0', textAlign: 'center', fontSize: '14px' }}>
              Delete base record of <strong>{formatValue(deleteConfirm)}</strong> from{' '}
              <strong>{formatTimestamp(deleteConfirm.timestamp)}</strong>?
            </p>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                onClick={cancelDelete}
                style={{
                  flex: 1,
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '6px',
                  backgroundColor: 'white',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                style={{
                  flex: 1,
                  padding: '10px',
                  border: 'none',
                  borderRadius: '6px',
                  backgroundColor: '#dc3545',
                  color: 'white',
                  cursor: 'pointer'
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}